<template>
<div id="app">

  <div class=" bg-white margin-center   backgroud margin-top-15" style="padding-top:10px; min-height: 550px;">
    <p v-if="totalAll!==0" class="font-size-24 font-color-black topbar">"{{key}}"的搜索结果共{{totalAll}}条</p>

    <div v-if="SearchCount!=null" class="flex topbarindex">
      <div class="flex flex-direction align-center margin-l-r-15" style="cursor: pointer;">
        <p @click="checkIndex(0)" :style="indexcheck==0?'color:#d30000':'color:#000000'"> 课程（{{SearchCount.CoursesCount}}） </p>
        <div class="topbarline" :style="indexcheck==0?'background: #d30000;':'backgroud:#ffffff'"></div>
      </div>
      <div class="flex flex-direction align-center margin-l-r-15" style="cursor: pointer;">
        <p @click="checkIndex(1)" :style="indexcheck==1?'color:#d30000':'color:#000000'"> 讲师（{{SearchCount.AuthorsCount}}） </p>
        <div class="topbarline" :style="indexcheck==1?'background: #d30000;':'backgroud:#ffffff'"></div>
      </div>
      <div class="flex flex-direction align-center margin-l-r-15" style="cursor: pointer;">
        <p @click="checkIndex(2)" :style="indexcheck==2?'color:#d30000':'color:#000000'"> 电子书（{{SearchCount.BooksCount}}） </p>
        <div class="topbarline" :style="indexcheck==2?'background: #d30000;':'backgroud:#ffffff'"></div>
      </div>
      <div class="flex flex-direction align-center margin-l-r-15" style="cursor: pointer;">
        <p @click="checkIndex(3)" :style="indexcheck==3?'color:#d30000':'color:#000000'"> 资讯（{{SearchCount.ArticlesCount}}） </p>
        <div class="topbarline" :style="indexcheck==3?'background: #d30000;':'backgroud:#ffffff'"></div>
      </div>

    </div>
    <div style="position: relative" id="searchDiv">
    <div v-if="indexcheck ==0" class="flex flex-wrap margin-top-30">
      <div v-for="(item, index) in courseList" :key="index+'courseList'" style="width: 280px;height: 254px; overflow: hidden;margin-left:20px; position: relative;" @click="clickVideo(item.Id,0)">
        <!-- <div class="courseHover" :style="{backgroundImage:'url('+item.Image+')'}">
          <div>
            <i class="subMask"></i>
            <i class="playIcon"></i>
          </div>
        </div> -->
        <div style=" width: 280px;height: 168px;">
          <img style=" width: 280px;height: 168px;" :src="item.Image" alt="">
        </div>
        <div class="courseHover">
          <!-- :style="{backgroundImage:'url('+item.Image+')'}" -->

          <div>
            <i class="subMask"></i>
            <i class="playIcon"></i>
          </div>
        </div>
        <div class="title">
          <img v-if="item.HasPPT" src="../../assets/img/ppt.png" alt="">
          <img v-if="item.HasWord" src="../../assets/img/word.png" alt="">
          <p  v-html="item.Title" class="font-color-333-red text-line1  font-size-16" style="text-decoration: none;text-align: left;line-height: 20px;cursor: pointer;"></p>

        </div>
        <p class="text-line1 font-color-999 text-left font-size-12" style="margin-top:3px;">主讲人：{{item.Lecturer}}</p>
      </div>
    </div>
    <div v-else-if="indexcheck ==1" class="flex flex-wrap margin-top-15">
      <div v-for="(item, index) in authorList" :key="index+'authorList'" class="lectureHover" @click="lectueIndex(item.Id)">
        <div class="backgroud" :style="{backgroundImage:'url('+item.AuthorImage+')'}">
        </div>
        <div class="flex flex-direction" style="flex:1;margin-left:12px;height: 100px;">
          <div class="flex " style="  align-items: center;height: 32px;">
            <p v-html="item.Name" class="author"></p>
            <p class="num">{{item.Videos.length}}课时</p>
          </div>
          <p v-html="item.Infos" class="infor"></p>
        </div>
      </div>
    </div>
    <div v-else-if="indexcheck == 2" class="flex flex-wrap margin-top-30">
      <div v-for="(item, index) in bookList" :key="index+'bookList'">
        <div class="bookHover" @mouseover="mouseover(index)" @mouseleave="mouseout()">

          <el-image class="image" :src="item.ImageUrl" fit="scale-down"></el-image>
          <p v-html="item.BookName" class="font-color-333-red text-line1  font-size-16" style="text-decoration: none;text-align: left;line-height: 20px;height: ; margin-top: 15px; z-index: 300;cursor: pointer;"></p>
          <p  class="text-line1 font-color-999 text-left font-size-12" style="margin-top:3px; "> 作者：{{item.Author}}</p>

          <div class="des" v-if="index == checkBook">
            <p class=" download" style="cursor: pointer;" @click="downloadUrl(item.DownloadUrl)">
              <img src="../../assets/img/download.png" alt="" style="    width: 13px;
    height: 12px;">
              下载
            </p>
            <div class="bg-white" style="padding:0 10px 10px;margin-top:28px">
              <p v-html="item.BookName" class="font-color-333-red text-line1  font-size-16" style="text-decoration: none;text-align: left;line-height: 20px;margin-top: 15px; z-index: 300;"></p>
              <p class="text-line1 font-color-999 text-left font-size-12" style="margin-top:2px; "> 作者：{{item.Author}}</p>

              <p class=" font-color-999 text-left font-size-12">ISBN：{{item.ISBN}}
              </p>

              <!--   <p class=" font-color-999 text-left ">出版社：{{item.Publisher}}
                            </p>-->
              <p  style="cursor: pointer;" v-html="'书籍简介：'+item.Introduction" class=" font-color-999 text-left text-3 margin-top-15">
              </p>
            </div>
          </div>
        </div>

      </div>

    </div>
    <div v-else class="flex flex-direction align-center ">
      <div  v-for="(item, index) in articlesList" :key="index+'articlesList'" :style="index!=0?'border-top: #eeeeee dashed 1px;':''" @click="articleIndex(item.Id)" class="information">
        <div :title="item.Title" class="flex font-size-20 font-color-black"  style="align-items: baseline;">
          <p class="text-line1 click"  v-html="item.Title" style="cursor: pointer;line-height:30px"></p>
          <span class=" font-size-14 font-color-999 " style="text-align:left;width: 160px;margin-left: 15px;">{{item.CreateTimeStr}}</span>
        </div>
        <p style="text-align: left;margin-top:14px"  v-html="item.Description" class=" font-size-14 font-color-999 text-line1"></p>
      </div>
    </div>
    <div v-if="loading" class="loading flex flex-center" style="position: absolute;">
      <i class="el-icon-loading" style="font-size: 30px;color: #fff"></i>
    </div>
   </div>
  </div>
  <div style=" margin-top: 20px; ">

    <el-pagination v-if="totalPage>1" :current-page.sync="currentPage" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="pageSize" layout="total,prev, pager, next" :total="totalPage">
    </el-pagination>
  </div>
  <Bottom></Bottom>
</div>
</template>

<script>
import common from '@/utils/common.js'

export default {
  name: 'app',
  props: {
    inputValue: {
      type: String,
      required: false
    }
  },
  data () {
    return {

      loading: false,
      checkBook: -1,
      key: '儿童',
      totalAll: 0,
      indexcheck: 0,
      SearchCount: null,
      courseList: [],
      authorList: [],
      bookList: [],
      articlesList: [],
      currentPage: 1,
      pageSize: 16,
      totalPage: 1
    }
  },
  watch: {
    $route (to, from) {
      if (this.$route.query.key) {
        this.key = this.$route.query.key || ''
        this.totalAll = 0
        this.currentPage = 1
        this.courseList = []
        this.authorList = []
        this.bookList = []
        this.articlesList = []
        this.getSearchCount()
      }
    }
  },
  // watch: {
  //   inputValue: function (value) {
  //     console.log(this.key + '----' + value)
  //     this.key = value
  //     this.currentPage = 1
  //     this.courseList = [],
  //     this.authorList = [],
  //     this.bookList = [],
  //     this.articlesList = [],
  //     this.getSearchCount()
  //     this.getSearchKey(1)
  //   }
  // },
  created () {
    this.key = this.$route.query.key || ''
    if (this.key == '') {
      this.$router.push({
        name: 'home'
      })
    } else {
      this.getSearchCount()
      // this.getSearchKey(1)
    }
  },

  methods: {
    lectueIndex (Id) {
      // this.$router.push({ path: '/lectrue', query: { "Id": Id } })

      let routeData = this.$router.resolve({
        path: '/lectrue',
        query: {
          'Id': Id
        }
      })
      window.open(routeData.href, '_blank')
    },
    articleIndex (Id) {
      // this.$router.push({ path: '/infordes', query: { "Id": Id } })
      let routeData = this.$router.resolve({
        path: '/infordes',
        query: {
          'Id': Id
        }
      })
      window.open(routeData.href, '_blank')
    },
    downloadUrl (path) {
      var token = common.getCookie('utoken')
      if (token != '') {
        window.open(path, '_blank')
      } else {
        localStorage.setItem('islogin_httpurl', window.location.href)
        let routeData = this.$router.resolve({
          name: 'black',
          params: {
            isfirst: 'first',
            states: 'login'
          }
        })
        window.open(routeData.href, '_blank')
        // localStorage.setItem('islogin_httpurl', window.location.href)
        // this.$router.replace({
        //   name: 'black',
        //   params: {
        //     isfirst: 'first',
        //     states: 'login'
        //   }
        // })
      }
    },
    clickVideo: function (courseId, videoId) {
      let routeData = this.$router.resolve({
        name: 'video',
        params: {
          sizheng: 'n',
          courseId: courseId,
          videoId: videoId
        }
      })
      window.open(routeData.href, '_blank')
    },
    mouseout () {
      this.checkBook = -1
    },
    mouseover (index) {
      this.checkBook = index
    },

    getStringColorReplace (text) {
      var color_temp = 'rgb(228,00,00)'
      var replaceString = '<span style="color: ' + color_temp + ';">' + this.key + '</span>'
      text = text.replace(RegExp(replace_text[i], 'g'), replaceString)

      return text
    },
    checkIndex (index) {
      if (this.indexcheck != index) {
        this.indexcheck = index
        if (this.currentPage == 1) {
          if (index == 0 && this.courseList.length == 0) {
            this.getSearchKey(1)
          } else if (index == 1 && this.authorList.length == 0) {
            this.getSearchKey(1)
          } else if (index == 2 && this.bookList.length == 0) {
            this.getSearchKey(1)
          } else if (index == 3 && this.articlesList.length == 0) {
            this.getSearchKey(1)
          }
        } else {
          this.currentPage = 1,
          this.getSearchKey(1)
        }
      }
    },
    handleSizeChange (val) {
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (val) {
      window.scrollTo(0, 0)
      // this.currentPage = 1,
      this.getSearchKey(val)
    },
    getSearchCount () {
      var that = this
      this.loading = true
      this.getRequest('api/v1/search/GetSearchCount', {
        KeyWord: this.key
      }).then(data => {
        if (data.IsSuccess) {
          that.SearchCount = data.Data
          that.totalAll = data.Data.CoursesCount + data.Data.AuthorsCount + data.Data.BooksCount + data.Data.ArticlesCount
          this.getSearchKey(1)
        } else {
          this.$message.error(data.Message)
        }
      })
    },
    getSearchKey (index) {
      this.loading = true
      var that = this
      var params = {}
      if (this.indexcheck == 0) {
        this.pageSize = 16
        params = {
          KeyWord: this.key,
          Type: 'course',
          PageIndex: index,
          PageSize: this.pageSize
        }
      } else if (this.indexcheck == 1) {
        this.pageSize = 15
        params = {
          KeyWord: this.key,
          Type: 'author',
          PageIndex: index,
          PageSize: this.pageSize
        }
      } else if (this.indexcheck == 2) {
        this.pageSize = 15
        params = {
          KeyWord: this.key,
          Type: 'book',
          PageIndex: index,
          PageSize: this.pageSize
        }
      } else {
        this.pageSize = 16
        params = {
          KeyWord: this.key,
          Type: 'article',
          PageIndex: index,
          PageSize: this.pageSize
        }
      }
      this.getRequest('api/v1/search/SearchByKeyWord', params).then(data => {
        this.loading = false
        if (data.IsSuccess) {
          // if ()
          if (that.indexcheck == 0) {
            // console.log("------" + data.Data.Courses.DataList);

            that.courseList = data.Data.Courses.DataList
            that.totalPage = data.Data.Courses.TotalCount
          } else if (that.indexcheck == 1) {
            that.authorList = data.Data.Authors.DataList
            that.totalPage = data.Data.Authors.TotalCount
          } else if (that.indexcheck == 2) {
            that.bookList = data.Data.Books.DataList
            that.totalPage = data.Data.Books.TotalCount
          } else {
            that.articlesList = data.Data.Articles.DataList
            that.totalPage = data.Data.Articles.TotalCount
          }
        } else {
          // this.$message.error(data.Message)
        }
      }).catch(err => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.title {
  display: flex;
  margin-top: 15px;
  align-items: center;
}

.title img {
  width: 14px;
  height: 16px;
  margin-right: 5px;
}

.title p {
  flex: 1;
}

body {
  background: #ffffff;
  padding: 0 0;
}

.topbar {
  text-align: left;
  padding-left: 21px;
  line-height: 80px;
}

.topbarindex {
  padding-left: 6px;
  line-height: 40px;
  font-size: 16px;
  color: #000000;
  border-bottom: #eeeeee solid 1px;
}

.topbarline {
  height: 4px;
  width: 32px;
}

.text-3 {
  height: 60px;
  line-height: 20px;
  overflow: hidden;
}

.backgroud {
  width: 1220px;

  background: #ffffff;
  box-shadow: 0px 3px 20px 0px #ececec;
}

.bookHover {
  width: 226px;
  height: 294px;
  padding: 10px;

  margin-left: 15px;
  position: relative;
}

.bookHover .image {
  width: 208px;
  height: 208px;
}

.bookHover .des {
  position: absolute;
  top: 0px;
  height: auto;
  width: 226px;

  left: 0px;
  z-index: 20;
}

.bookHover .des::after {
  position: relative;
  content: " ";
  width: 200%;
  height: 200%;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: inherit;
  transform: scale(0.5);
  transform-origin: 0 0;
  pointer-events: none;
  box-sizing: border-box;
  border: 1px solid #ebebeb;
}

.bookHover .des .download {
  width: 69px;
  height: 32px;
  line-height: 32px;
  color: #ffffff;
  font-size: 14px;
  margin-left: 150px;
  margin-top: 179px;
  background: #d30000;
  border-radius: 4px;
  z-index: 200px;
}

.bookHover .des div,
p {
  text-decoration: none;
  z-index: 200px;
}

.lectureHover {
  width: 389px;
  height: 100px;
  overflow: hidden;

  margin: 15px 0 15px 15px;
  cursor: pointer;
  display: flex;
}

.lectureHover .backgroud {
  width: 100px;
  height: 100px;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
}

.lectureHover .author {
  font-size: 14px;

  color: #000000;
  line-height: 32px;
}

.lectureHover .num {
  font-size: 12px;
  margin-left: 12px;
  color: #999999;

  text-align: left;

  line-height: 20;
}

.lectureHover .infor {
  font-size: 12px;
  /* margin-left: 12px; */
  color: #999999;
  max-height: 70px;
  text-align: left;
  /* height: 60px; */
  /* line-height: 20; */
}

.courseHover {
  width: 280px;
  height: 168px;
  overflow: hidden;
  margin-top: -168px;
  background-size: cover;
  background-repeat: no-repeat;
}

.courseHover div {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.courseHover .subMask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.3;
  filter: alpha(opacity=30);
  z-index: 0;
}

.courseHover .playIcon {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 6;
  opacity: 0;
  margin: -30px 0 0 -30px;
  width: 60px;
  height: 60px;
  background: url(https://h5.cdn.bjadks.com/website/wsbgt-zt/999-linshi_szk/play-icon1.png) no-repeat;
  filter: alpha(opacity=0);
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  -webkit-transform: scale(1.5);
  -moz-transform: scale(1.5);
  -ms-transform: scale(1.5);
  transform: scale(1.5);
}

.courseHover div:hover .subMask {
  display: block;
  z-index: 5;
}

.courseHover div:hover .playIcon {
  z-index: 6;
  opacity: 1;
  filter: alpha(opacity=100);
  transform: scale(1);
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
}

.information {
  box-sizing: border-box;
  width: 1159px;
  padding: 20px 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  /* border-bottom: #eeeeee dashed 1px; */
}
.loading{
  width: 150px;
  height: 150px;
  border-radius: 10px;
  margin-left: -75px;
  left: 50%;
  top: 50px;
  z-index: 1000;
  background: rgba(0,0,0,0.3);
}
</style>



// WEBPACK FOOTER //
// src/views/search/index.vue